import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { InputField } from '@booking/pages/liveqHome/liveqSteps/components/inputField';
import styles from './index.module.scss';
export const BmiCalculator = ({ value, errors, onChange }) => {
    const onHandleChange = (name, val) => {
        if (name === 'heightFeet') {
            if (!val) {
                onChange(name, undefined);
                setFeet('');
                return;
            }
            else if (!inches) {
                onChange(name, undefined);
            }
            else {
                onChange(name, (parseInt(val) * 12 + parseInt(inches)).toString());
            }
            setFeet(val);
        }
        else if (name === 'heightInches') {
            if (!val) {
                onChange(name, undefined);
                setInches('');
                return;
            }
            else if (!feet) {
                onChange(name, undefined);
            }
            else {
                onChange(name, (parseInt(feet) * 12 + parseInt(val)).toString());
            }
            if (parseInt(val) > 11) {
                setInches((parseInt(val) % 12).toString());
                setFeet(el => (parseInt(el) + ((parseInt(val) / 12) | 0)).toString());
                return;
            }
            setInches(val);
        }
    };
    const [feet, setFeet] = useState('');
    const [inches, setInches] = useState('');
    return (_jsx("div", { children: _jsx("div", Object.assign({ className: styles.inputsRow }, { children: _jsxs("div", Object.assign({ className: styles.double }, { children: [_jsx(InputField, { label: "Height, feet", name: "heightFeet", value: feet, onChange: onHandleChange, className: styles.left, wrapperClassName: styles.inputsWrapper }), _jsx(InputField, { label: "inches", name: "heightInches", value: inches, onChange: onHandleChange, className: styles.right, wrapperClassName: styles.inputsWrapper })] })) })) }));
};
